module.exports = __webpack_public_path__ + "img/tag8.6075c5a5.png";